module.exports = __webpack_public_path__ + "static/media/vegitables_79.51b4dac7.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_79.csv
// module id = 667
// module chunks = 0